import { render, staticRenderFns } from "./FormStepper.vue?vue&type=template&id=2e2f8514&scoped=true"
import script from "./FormStepper.vue?vue&type=script&lang=js"
export * from "./FormStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2f8514",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardActions})
